import React, { useCallback, useEffect, useState } from "react";
import {
  View,
  Text,
  Image,
  BackHandler,
  Platform,
  StatusBar,
  TouchableOpacity,
} from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import * as Location from "expo-location";
import * as Linking from 'expo-linking';
import { useNavigation } from "@react-navigation/native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { useSafeAreaInsets } from "react-native-safe-area-context";

import styles from "../../styles/profileStyle";
import dimensions from "../../../../globalStyles/dimensions";
import GlobalStyles from "../../../../globalStyles/globalStyles";
import CustomComponent from "../../../../components/CustomComponent";
import { Colors } from "../../../../globalStyles/ColorConfig";
import { handleBackButton } from "../../components/BackButtonAlert";
import { useBackButtonHandler } from "../../hooks/useBackHandler";
import {
  updateData,
  updateDataImage,
} from "../../../../services/Profile/profileService";
import { PROFILE_ROUTES } from "../../../../navigation/routes";

const GrantLocationAccess = () => {
  const navigation = useNavigation();
  const [take, setTake] = useState(false);
  const [location, setLocation] = useState<Location.LocationObject | null>(
    null
  );
  const [errorMsg, setErrorMsg] = useState<string | null>(null);
  useBackButtonHandler(handleBackButton, [navigation]);
  const setStaticScreenHide = async () => {
    try {
      await AsyncStorage.setItem("hideStaticScreen", "true");
    } catch (error) {
      console.error("Error setting value in local storage:", error);
    }
  };

  useEffect(() => {
    setStaticScreenHide();
    
  }, []);

  const handleGrantLocation = async () => {
    // navigation.navigate(PROFILE_ROUTES.ONBOARD_ALLDONE as never);
    let { status } = await Location.requestForegroundPermissionsAsync();
    console.log("====================================");
    console.log("status", status);
    console.log("====================================");

    if (status !== "granted") {
      setErrorMsg(
        "You need to give us the location access. Go to settings and grant access"
      );
      Linking.openSettings()
      setTake(true); // Show an error message
      return;
    }
    if (status === "granted") {
      setTake(false);
    }

    let location = await Location.getCurrentPositionAsync({});
    setLocation(location);
    console.log("====================================");
    console.log("location", location);
    console.log("====================================");
    if (location) {
      // hit post api to send lat and long
      const response = await updateData({
        userInfo: {
          geolocation: {
            latitude: location.coords.latitude,
            longitude: location.coords.longitude,
          },
        },
      });

      updateDataImage({
        userInfo: {
          geolocation: {
            latitude: location.coords.latitude,
            longitude: location.coords.longitude,
          },
        },
      });
     
      if (response) {
        navigation.navigate(PROFILE_ROUTES.ONBOARD_ALLDONE as never);
      }
    }
  };
  const insets = useSafeAreaInsets();

  return (
    // <View style={styles.Wrapper}>
    //   <StatusBar
    //     translucent
    //     backgroundColor={"transparent"}
    //     barStyle={"light-content"}
    //   />
    //   <View
    //     style={{
    //       position: "absolute",
    //       height: dimensions.windowHeight / 1.5,
    //       width: Platform.OS === "web" ? 390 : dimensions.windowWidth * 2.1,
    //       top: 0,
    //     }}
    //   >
    //     <Image
    //       source={{
    //         uri: "https://hushl-spark-dev.s3.ap-south-1.amazonaws.com/frontend-assets/onboarding/grantaccess.webp",
    //       }}
    //       resizeMode="cover"
    //       style={{
    //         width: Platform.OS === "web" ? 390 : "100%",
    //         height: "100%",
    //       }}
    //     />
    //     <LinearGradient
    //       colors={["transparent", "rgba(0,0,0,1)"]}
    //       style={{
    //         position: "absolute",
    //         width: "100%",
    //         height: dimensions.windowHeight / 4,
    //         bottom: 0,
    //       }}
    //     />
    //   </View>
    //   <View
    //     style={{
    //       position: "absolute",
    //       bottom: 40,
    //       width: Platform.OS === "web" ? 390 : dimensions.windowWidth,
    //       height: dimensions.windowHeight / 3.2,
    //       paddingHorizontal: 16,
    //     }}
    //   >
    //     <View style={{}}>
    //       <Text
    //         style={[
    //           styles.showOffText,
    //           GlobalStyles.heading2,
    //           { color: "white" },
    //         ]}
    //       >
    //         We would like to know your location, so we can show you the profile
    //         in your locality
    //       </Text>
    //     </View>
    //     <CustomComponent.AppBtn
    //       name={take ? "Allow Location access in settings " : "Grant access"}
    //       style={{
    //         backgroundColor: Colors.black100,
    //         borderRadius: 40,
    //         marginVertical: dimensions.marginVertical,
    //         borderWidth: 0.5,
    //         borderColor: Colors.grey300,
    //         justifyContent: "center",
    //       }}
    //       textStyle={[GlobalStyles.bodyText, { color: Colors.white10 }]}
    //       onPress={() => {
    //         handleGrantLocation();
    //       }}
    //     />
    //   </View>
    //   {take && (
    //     <View
    //       style={{
    //         width: "80%",
    //         marginTop: 10,
    //         position: "absolute",
    //         top: "56%",
    //         backgroundColor: "rgba(255,0,0,0.1)",
    //         borderRadius: 10,
    //         padding: 10,
    //         borderColor: "rgba(255,0,0,0.3)",
    //         borderWidth: 1,
    //       }}
    //     >
    //       <Text
    //         style={{
    //           color: "rgba(255,0,0,0.8)",
    //           fontSize: 14,
    //           textAlign: "center",
    //           fontFamily: "InterRegular",
    //         }}
    //       >
    //         {errorMsg ||
    //           "You need to give us the location access. Go to settings and grant access"}
    //       </Text>
    //     </View>
    //   )}
    // </View>
    <View
      style={{
        height: "100%",
        width: "100%",
        paddingBottom: insets.bottom,
      }}
    >
      <StatusBar
        translucent
        backgroundColor={"transparent"}
        barStyle={"light-content"}
      />
      <Image
        source={{
          uri: "https://hushl-spark-dev.s3.ap-south-1.amazonaws.com/frontend-assets/onboarding/grantaccess.webp",
        }}
        resizeMode="cover"
        style={{
          width: "100%",
          height: dimensions.windowHeight / 1.2,
        }}
      />
      <View style={{ position: "absolute", zIndex: 2, bottom: 0 }}>
        <LinearGradient
          colors={["transparent", "rgba(0,0,0,1)"]}
          style={{
            width: dimensions.windowWidth,
            height: dimensions.windowHeight / 2,
            bottom: 0,
            zIndex: 2,
          }}
        />
        <View
          style={{
            backgroundColor: Colors.black100,
            paddingHorizontal: 16,
            paddingBottom: 10,
          }}
        >
          <Text
            style={[
              styles.showOffText,
              GlobalStyles.heading2,
              {
                color: "white",
                fontFamily: "EBGaramondMedium",
                letterSpacing: -0.3,
                fontSize: 36,
                lineHeight: 38,
                paddingHorizontal: 10,
              },
            ]}
          >
            Your location will help us show you profiles in your area.
          </Text>
          <TouchableOpacity
            style={{
              backgroundColor: Colors.black100,
              borderRadius: 40,
              marginVertical: dimensions.marginVertical,
              borderWidth: 0.5,
              borderColor: Colors.grey300,
              justifyContent: "center",
              paddingVertical: 16,
            }}
            onPress={() => handleGrantLocation()}
          >
            <Text
              style={[
                GlobalStyles.bodyText,
                {
                  color: "#BEBEBE",
                  textAlign: "center",
                  fontFamily: "InterSemiBold",
                  letterSpacing: -0.16,
                },
              ]}
            >
              {take ? "Allow Location access in settings " : "Grant access"}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
      {take && (
        <View
          style={{
            width: "100%",
            position: "absolute",
            top: "60%",
            zIndex: 3,
            alignContent: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <View
            style={{
              width: "90%",
              marginHorizontal: "auto",
              alignContent: "center",
              margin: "auto",
              zIndex: 3,
              backgroundColor: "rgba(255,0,0,0.1)",
              borderRadius: 10,
              padding: 10,
              borderColor: "rgba(255,0,0,0.3)",
              borderWidth: 1,
            }}
          >
            <Text
              style={{
                color: "rgba(255,0,0,0.8)",
                fontSize: 14,
                textAlign: "center",
                fontFamily: "InterRegular",
              }}
            >
              {errorMsg ||
                "You need to give us the location access. Go to settings and grant access"}
            </Text>
          </View>
        </View>
      )}
    </View>
  );
};

export default GrantLocationAccess;
